import React, { useContext } from 'react';
import { AppContext } from '@ctsu/loader';
import { toLower, uniq } from 'lodash/fp';
import AppBody from './AppBody';
import dataJson from './permission.json';

const APPNAME = process.env.REACT_APP_NAME;

export default function Permission() {
  const { common } = dataJson;
  const {
    session: { userPermissions },
    application
  } = useContext(AppContext);
  const { appConfig: { UN_AUTHORIZED_USER_MSG_PRIMARY } = {} } = application || [];

  let memo = UN_AUTHORIZED_USER_MSG_PRIMARY;
  const userAppNames = uniq(userPermissions.map(a => a.split('.')[0]));
  const permissions = userAppNames.indexOf(toLower(APPNAME)) > -1;

  if (!permissions) {
    memo = common.access_denied;
  }
  // sonar issue fix
  const decodedMailto = window.atob(common.mailTo);
  return (
    <AppBody bodyClassNames="align-center">
      <p className="align-center content-page-title">{memo}</p>
      <p>
        {common.no_role_message}
        {' '}
        {common.contact_help_desk1}
        <a href={decodedMailto} className="mx-1" target="_top">
          {common.contact_help_desk2}
        </a>
        {common.contact_help_desk3}
      </p>
    </AppBody>
  );
}
